import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
} from "reactstrap"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
import { assessmentValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import axios from "axios"
import FileDisplay from "components/custom/FileDisplay"
import {
  createAssessmentMasterMutation,
  updateAssessmentMasterMutation,
  deleteAssessmentMasterMutation,
  getAllAssessmentMasterQuery,
  getOneAssessmentMasterQuery,
  fileUploadQuery,
  getAllAgeGroup,
} from "./Queries"
import { Helmet } from "react-helmet-async"
import { StatusCodes } from "../../constants/defaultValues"

class AssessmentMaster extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],

      pageLimit: 25,
      totalCount: 0,
      keyField: "id",
      viewModal: false,
      assessmentMasterList: [],

      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 25,
      },
      assessmentMaster: {},
      columns: [
        {
          name: "Icon",
          selector: row => row.iconURL,
          sortable: true,
          width: "10%",
          cell: row => (
            <span style={{ padding: "10px" }}>
              <img
                style={{ width: "50px", height: "50px" }}
                src={row.iconURL}
                alt={row.iconURL}
              />
              {/* {row.iconURL ? <FileDisplay Value={row.iconURL} /> : ""} */}
            </span>
          ),

          // <a href={row.iconURL}>{row.iconURL ? row.iconURL : ""}</a>
        },
        {
          name: "Name",
          selector: row => row.assessmentName,
          sortable: true,
          cell: row => (
            <span>{row.assessmentName ? row.assessmentName : ""}</span>
          ),
        },

        // {
        //   name: "Age Group",
        //   selector: "ageGroupId",
        //   sortable: true,
        //   cell: row => <span>{row.ageGroupId ? row.ageGroupId : ""}</span>,
        // },

        // {
        //   name: "Icon",
        //   selector: "iconURL",
        //   sortable: true,
        //   cell: row => (
        //     <a href={row.iconURL}>{row.iconURL ? row.iconURL : ""}</a>
        //   ),
        // },

        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllAssessmentMaster()
    //this.getAllAgeGroup()
  }

  // getAllAgeGroup = async () => {
  //   await QueryRequest(getAllAgeGroup).then(res => {
  //     this.setState({
  //       ageGroupList: res.data?.getAllAgeGroupMasters?.items.map(function (a) {
  //         return { value: a.id, label: a.ageGroupTitle }
  //       }),
  //     })
  //   })
  //   //console.log(this.state.ageGroupList)
  // }

  getAllAssessmentMaster = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllAssessmentMasterQuery, values)
    var assessmentMastersValue = response?.data?.getAllAssessmentMasters?.items
    //console.log(assessmentMastersValue)
    if (assessmentMastersValue) {
      this.setState({
        isLoading: false,
        assessmentMasterList: assessmentMastersValue,
        totalPage:
          response?.data?.getAllAssessmentMasters?.pagination?.totalCount /
          response?.data?.getAllAssessmentMasters?.pagination?.pageLimit,
        totalCount:
          response?.data?.getAllAssessmentMasters?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllAssessmentMaster()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllAssessmentMaster()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllAssessmentMaster()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllAssessmentMaster()
        }
      }
    )
  }

  handleEdit = row => {
    if (row) {
      this.setState({
        assessmentMaster: row,
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }

  /** Submit Function Start */
  handleSubmit = async values => {
    this.state.Label == "Add"
      ? this.addAssessmentMaster(values)
      : this.editAssessmentMaster(values)

    // if (values.iconURL) {
    //   let fileupload = {
    //     type: "photo",
    //     fileName: values.iconURL.name,
    //   }
    //   const fileUploadresponse = await QueryRequest(fileUploadQuery, fileupload)
    //   let data = fileUploadresponse?.data?.getUploadUrl
    //   if (data.status === "Success") {
    //     axios
    //       .put(data.url, values.iconURL, {
    //         headers: { "Content-Type": values.iconURL?.type },
    //       })
    //       .then(res => {
    //         if (res.status.toString() === StatusCodes.Success) {
    //           //console.log("fileName res" + JSON.stringify(res))
    //           values.iconURL = data.url.split("?")[0]
    //           return this.documentUpload(values)
    //         } else {
    //           ErrorMessage(Message("fieldUpload.error"))
    //           const response = MutateRequest(createJobApplicationMutation, val)
    //           var candidateValue = response?.data
    //           if (candidateValue) {
    //             SuccessMessage(Message("jobapplication.add")),
    //               this.setState({
    //                 manageModal: !this.state.manageModal,
    //               })
    //             this.getAllJobApplication()
    //           }
    //         }
    //       })
    //   } else {
    //     ErrorMessage(Message("fieldUpload.error"))
    //   }
    // }

    // const response = values.id
    //   ? await MutateRequest(updateAssessmentMasterMutation, values)
    //   : await MutateRequest(createAssessmentMasterMutation, values)
    // var assessmentMasterValue = response?.data
    // if (assessmentMasterValue && values.id) {
    //   SuccessMessage(Message("assessmentMaster.update")),
    //     this.setState({
    //       manageEditModal: !this.state.manageEditModal,
    //     })
    //   this.getAllAssessmentMaster()
    // } else {
    //   SuccessMessage(Message("assessmentMaster.add")),
    //     this.setState({
    //       manageModal: !this.state.manageModal,
    //     })
    //   this.getAllAssessmentMaster()
    // }
  }
  addAssessmentMaster = async values => {
    let data = {
      assessmentName: values.assessmentName,
    }
    if (values.ageGroupId) data.ageGroupId = values.ageGroupId
    if (values.iconURL) data.iconURL = values.iconURL
    await MutateRequest(createAssessmentMasterMutation, { data: data })
      .then(res => SuccessMessage(Message("assessment.add")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllAssessmentMaster()
  }

  editAssessmentMaster = async values => {
    let Data = {
      id: this.state.assessmentMaster.id,
      data: {
        assessmentName: values.assessmentName,
      },
    }
    if (values.ageGroupId) Data.data.ageGroupId = values.ageGroupId
    if (values.iconURL) Data.data.iconURL = values.iconURL
    //console.log(Data)
    await MutateRequest(updateAssessmentMasterMutation, Data)
      .then(res => SuccessMessage(Message("assessment.update")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllAssessmentMaster()
  }

  addBtnClick = () => {
    this.setState({
      assessmentMaster: {},
      manageModal: !this.state.manageModal,
      Label: "Add",
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      assessmentMaster: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      assessmentMaster: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteAssessmentMaster = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteAssessmentMasterMutation, values)
    var assessmentMasterdeleteValue = response?.data
    if (
      assessmentMasterdeleteValue.deleteOneAssessmentMaster.status === "Success"
    ) {
      SuccessMessage(Message("assessment.delete"))
      this.getAllAssessmentMaster()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      assessmentMasterDetail: url ? url : "",
    })
  }

  render() {
    const initialValues = this.state.assessmentMaster
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.assessmentMaster")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"Self Assessments"}`}
                  buttonText={Message("add.assessment")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                <Row></Row>

                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.assessmentMasterList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  pageSizeOptions={this.state.pageSizeOptions}
                  // rowClicked={this.HandleRowClicked}
                  pageLimit={this.state.pageLimit}
                  onSort={this.handleSort}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.assessment")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        {" "}
                        <strong>
                          {" "}
                          {this.state.assessmentMaster?.assessmentName}
                        </strong>{" "}
                        {Message("assessment")}{" "}
                      </span>
                      {"?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() =>
                      this.deleteAssessmentMaster(
                        this.state.assessmentMaster.id
                      )
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="md"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.assessment")
                  : Message("update.assessment")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={assessmentValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("name")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="assessmentName"
                                type="text"
                              />
                              {errors.assessmentName && (
                                <div className="invalid-feedback d-block">
                                  {errors.assessmentName}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("Image")}
                              </Label>
                              <Input
                                type="file"
                                name="iconURL"
                                id="iconURL"
                                onChange={async e => {
                                  let file = e.target.files[0]
                                  let fileupload = {
                                    type: "photo",
                                    fileName: e.target.files?.[0]?.name.trim(),
                                  }
                                  console.log(e.target.files[0])
                                  const fileUploadresponse = await QueryRequest(
                                    fileUploadQuery,
                                    fileupload
                                  )
                                  let data =
                                    fileUploadresponse?.data?.getUploadUrl
                                  let url = data.url.split("?")[0]
                                  axios
                                    .put(data.url, file, {
                                      headers: {
                                        "Content-Type": file.type,
                                      },
                                    })
                                    .then(async res => {
                                      console.log(res)
                                      if (
                                        res.status.toString() ===
                                        StatusCodes.Success
                                      ) {
                                        console.log(res.config.url)
                                      } else {
                                        ErrorMessage(
                                          Message("fieldUpload.error")
                                        )
                                      }
                                    })
                                    .catch(err => alert("Image"))
                                  setFieldValue("iconURL", url)
                                  // this.handleImageChange(e)
                                }}
                              />
                              {values.iconURL && (
                                <img
                                  src={values.iconURL}
                                  alt="preview"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "200px",
                                  }}
                                />
                              )}
                            </FormGroup>
                            {errors.iconURL && (
                              <div className="invalid-feedback d-block">
                                {errors.iconURL}
                              </div>
                            )}
                          </Col>
                          {/* <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <DropDown
                                label="Age Group"
                                components={{
                                  Input: CustomSelectInput,
                                }}
                                className="react-select"
                                classNamePrefix="react-select"
                                isSearchable
                                isClearable={true}
                                value={
                                  values.ageGroupId &&
                                  (typeof values.ageGroupId === "string"
                                    ? this.state.ageGroupList.find(
                                        r => r.value === values.ageGroupId
                                      )
                                    : this.state.ageGroupList.find(
                                        r => r.value === values.ageGroupId
                                      ))
                                }
                                options={this.state.ageGroupList}
                                ClearAction={() => {
                                  setFieldValue(`ageGroupId`, "")
                                }}
                                Action={entity => {
                                  setFieldValue(
                                    `ageGroupId`,
                                    entity ? entity.value : ""
                                  )
                                }}
                                errors={errors?.ageGroupId}
                              />
                              
                            </FormGroup>
                          </Col>
                          <Col lg="8" xl="8" sm="8" md="8" xs="8">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label>Icon</Label>
                              <br />
                              <Input
                                style={{ display: "none" }}
                                id="Image"
                                type="file"
                                onChange={e => {
                                  this.setState({
                                    photo: e.target.files[0],
                                  })
                                  setFieldValue("iconURL", e.target.files[0])
                                }}
                                
                              />
                              
                              <label for="Image" class="btn btn-secondary">
                                <i class="far fa-file"></i>                              
                              </label>


                              <br />
                              {values.iconURL ? (
                                <Label>{values.iconURL?.name}</Label>
                              ) : (
                                ""
                              )}
                              {errors.iconURL && (
                                <div className="invalid-feedback d-block">
                                  {errors.iconURL}
                                </div>
                              )}
                            </FormGroup>
                          </Col> */}
                        </Row>
                      </Fragment>
                    </ModalBody>

                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatoryFields")}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button type="submit" color="primary">
                                  {this.state.Label == "Edit"
                                    ? "Update"
                                    : "Add"}
                                </Button>

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(AssessmentMaster)
